import { render, staticRenderFns } from "./ContactsIndex.vue?vue&type=template&id=10e0da05&lang=pug"
import script from "./ContactsIndex.vue?vue&type=script&lang=js"
export * from "./ContactsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports